import type { ScreenSchema } from './types';

// For subunit-end screens, heading/subheading/text come from YAML and schema text
// derivation works normally (overrideText is undefined). For regular unit-end screens,
// content comes from injected store data; the template watcher passes pageTitle as
// overrideText. managesOwnSectionAudio: true suppresses uc-screen's generic watcher.
const unitEndSchema: ScreenSchema = {
  template: ['unit-end', 'subunit-end'],
  managesOwnSectionAudio: true,
  slots: {
    intro: {
      parts: [
        { field: 'heading', fallback: ['subheading', 'title'] },
        { field: 'text' }
      ]
    }
  }
};

export default unitEndSchema;
